import { render, staticRenderFns } from "./app_wrapper.vue?vue&type=template&id=48957d02&scoped=true"
import script from "./app_wrapper.vue?vue&type=script&lang=js"
export * from "./app_wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48957d02",
  null
  
)

export default component.exports